import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteAppointments, FetchAllAppointments } from "src/Thunk/adminThunks";
import { FetchStatus } from "src/Utils/getAppointmentStatus";
import { clearMsg } from "src/Actions/Admin/adminActions";
const MySwal = withReactContent(Swal);

const AppointmentList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteSuccess, setDeleteSuccess] = useState(true);
  let itemsPerPage = 10;
  const { appointmentList, msg, error } = useSelector((state) => state.admin);

  useEffect(() => {
    if (deleteSuccess) {
    dispatch(FetchAllAppointments());
    }
  }, [deleteSuccess]);

  const filteredAppointments = appointmentList.filter((customer) =>
    Object.values(customer).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredAppointments?.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    if (msg) {
      MySwal.fire({
        icon: "success",
        title: msg,
      });
      setTimeout(() => {
        dispatch(clearMsg());
      }, 1200);
      setDeleteSuccess(false);
      setTimeout(() => {
        setDeleteSuccess(true);
      }, 1000);
    }
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
    }
  }, [msg, error]);


  const handleDeleteAppointment = (id) => {
    dispatch(DeleteAppointments(id))
  }

  return (
    <div className="main-content">
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 text-info">APPOINTMENT LIST</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item text-info active">
                      Appointment List
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="card custom-shadow rounded-lg border my-3">
                <div className="card-body">
                  <Row>
                    <Col md={4} xs={12} className="mb-3 text-center">
                      <h3 className="fw-bolder text-info mb-0">
                        {appointmentList.length || 0}
                      </h3>
                      <p className="text-secondary">Total Appointments</p>
                    </Col>
                  </Row>

                  <div className="dataTables_length mb-2">
                   
                    <div className="search-box">
                      <input
                        type="text"
                        id="search"
                        placeholder="Search "
                        name="search"
                        className="form-control "
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                          <th>Patient Name </th>
                          <th>Appointed Doctor</th>
                          <th>Appointment Type</th>
                          <th>Appointment Date</th>
                          <th>Appointment Time</th>
                          <th>Clinic Address</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems?.map((itx, index) => (
                          <tr key={index}>
                            <td>{itx.patient_name}</td>
                            <td>{itx.doctor_name}</td>
                            <td>{itx.appointment_type}</td>
                            <td>{itx.appointment_date}</td>
                            <td>{itx.appointment_time}</td>
                            <td>{itx.clinic_address ? itx.clinic_address.substring(1,30) : 'NA'}</td>
                            <td className={FetchStatus(itx.appointment_date,itx.appointment_time) == "upcoming" ? "upcoming-status-txt" : FetchStatus(itx.appointment_date,itx.appointment_time) === "ongoing" ? "ongoing-status-txt" : "past-status-txt"}>
                              {FetchStatus(itx.appointment_date,itx.appointment_time) }
                             
                            </td>
                            {/* <td>
                              <div className="icon-container">
                                <Button
                                  variant="danger"
                                  size="sm"
                                  title="Delete Appointment"
                                  onClick={() => {
                                    MySwal.fire({
                                      title: "Are you sure?",
                                      text: "Once deleted, you will not be able to recover this data!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "No, cancel!",
                                      reverseButtons: true,
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        handleDeleteAppointment(itx.appointmentId)
                                      }
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </div>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Container>
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_length">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(indexOfLastItem, appointmentList.length || 0)}{" "}
                        of {appointmentList.length || 0} entries
                      </div>
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(
                          appointmentList.length / itemsPerPage
                        ),
                      }).map((_, index) => (
                        <button
                          key={index}
                          type="button"
                          className="btn btn-primary btn-circle btn-sm text-white m-1"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AppointmentList;
